export const radius = {
    button: '0.3rem',
    small: '0.5rem',
    medium: '1rem',
    large: '3rem'
};
//# sourceMappingURL=radius.js.map